// extracted by mini-css-extract-plugin
export default {"banner":"BannerNarrow_banner__ktU9K","content":"BannerNarrow_content__MR44G","buttons":"BannerNarrow_buttons__CqgsW","image":"BannerNarrow_image__Vok8t"};